import Icon from '@/components/icons/Icon';
import { TabAction } from '..';
import { TopTabBarItem as TopTabBarItemProps } from '../types';

const TopTabBarItem = ({ selected, label, onClick, to, isSubMenu, count }: TopTabBarItemProps) => {
  label += selected && count ? ` (${count} st)` : '';
  return isSubMenu ? (
    <TabAction
      className={`flex flex-col items-center rounded-full text-sm ${selected ? 'bg-black-900' : 'bg-black-100'}`}
      onClick={onClick}
      to={to}>
      <div className="text-m py-xs px-lg relative flex h-[30px] w-max items-center">
        <span className={`${selected ? 'text-white' : 'text-black-600'}`}>{label}</span>
        {selected && <Icon variant="check" color="white" size="sm" className="pl-xs float-right" />}
      </div>
    </TabAction>
  ) : (
    <TabAction className="flex w-full flex-col items-center text-sm" onClick={onClick} to={to}>
      <div className="relative h-[27px] w-max text-sm">
        <span className={`pb-xs ${selected ? 'text-black-900 border-b-2' : 'text-black-600'}`}>{label}</span>
      </div>
    </TabAction>
  );
};

export default TopTabBarItem;
